module.exports = __webpack_public_path__ + "static/media/uploadCloudSmall.5660a18a.svg";